"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productQueries = exports.productQueryKeys = void 0;
const product_api_1 = require("./product.api");
exports.productQueryKeys = {
    all: () => ['product'],
    information: ({ productCode, colorId }) => [...exports.productQueryKeys.all(), 'information', productCode, colorId],
    comparisonFeatures: (productId) => [...exports.productQueryKeys.all(), 'comparisonFeatures', productId],
};
const productQueries = (apiOptions) => ({
    getInformation: (params) => ({
        queryKey: exports.productQueryKeys.information(params),
        queryFn: () => (0, product_api_1.getInformation)(apiOptions, params),
    }),
    getComparisonFeatures: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.productQueryKeys.comparisonFeatures(params.productId), queryFn: () => (0, product_api_1.getComparisonFeatures)(apiOptions, params) })),
});
exports.productQueries = productQueries;
//# sourceMappingURL=product.queries.js.map